import { useEffect } from "react";

const WIDGET_ID = "zsiqscript";
const WIDGET_SRC =
  "https://salesiq.zohopublic.com/widget?wc=siq7e87ddf2b67926b6bf292c13e77aaf2b7f1de4a05991b089505fdaf06361ab34";
const TRACKING_DOMAIN =
  "LearningplusLearning Plus PH – Love learning. Love teaching.";
const IDLE_DELAY_MS = 5000;

type ZohoSalesIq = {
  ready?: () => void;
  tracking?: { domain: (domain: string) => void };
};

declare global {
  interface Window {
    $zoho?: { salesiq?: ZohoSalesIq };
  }
}

function loadSalesIq() {
  if (document.getElementById(WIDGET_ID)) return;
  const zoho = window.$zoho ?? {};
  window.$zoho = zoho;
  zoho.salesiq = zoho.salesiq ?? {
    ready() {
      window.$zoho?.salesiq?.tracking?.domain(TRACKING_DOMAIN);
    },
  };
  const script = document.createElement("script");
  script.id = WIDGET_ID;
  script.src = WIDGET_SRC;
  script.defer = true;
  document.body.appendChild(script);
}

export function SalesIq() {
  useEffect(() => {
    const events = ["pointerdown", "keydown", "scroll"] as const;
    let timer = 0;
    const cleanup = () => {
      window.clearTimeout(timer);
      for (const event of events) window.removeEventListener(event, start);
    };
    function start() {
      cleanup();
      loadSalesIq();
    }
    timer = window.setTimeout(start, IDLE_DELAY_MS);
    for (const event of events) {
      window.addEventListener(event, start, { once: true, passive: true });
    }
    return cleanup;
  }, []);
  return null;
}
